import { set } from 'lodash';

import { SimuliveVideoRoomState } from '.';

const mutations = {
  setIsHLSFragLoadError(state: SimuliveVideoRoomState, isError: Boolean) {
    state.isHLSFragLoadError = isError;
  },
  setIsHLSLevelLoadError(state: SimuliveVideoRoomState, isError: Boolean) {
    state.isHLSLevelLoadError = isError;
  },
  setIsHLSManifestLoadError(state: SimuliveVideoRoomState, isError: Boolean) {
    state.isHLSManifestLoadError = isError;
  },
  resetIsHLSFragLoadError(state: SimuliveVideoRoomState) {
    state.isHLSFragLoadError = false;
  },
  resetIsHLSLevelLoadError(state: SimuliveVideoRoomState) {
    state.isHLSLevelLoadError = false;
  },
  resetIsHLSManifestLoadError(state: SimuliveVideoRoomState) {
    state.isHLSManifestLoadError = false;
  },
  switchToNonInHouseSimulive(state: SimuliveVideoRoomState) {
    state.forceSwitchToNonInHouseSimulive = true;
  },
  setShowOverlayCaptions(state: SimuliveVideoRoomState, show: boolean) {
    state.showOverlayCaptions = show;
  },
  setVttAvailableCaptions(state: SimuliveVideoRoomState, captions: any) {
    state.vttAvailableCaptions = captions;
  }
};

export default mutations;
export type SimuliveVideoRoomMutations = typeof mutations;
